/** Friendly mapping of Firebase auth error codes to copy. */
export function authMessage(err: unknown): string {
  const code = (err as { code?: string })?.code ?? '';
  // Native Google/Apple sheets (Capacitor plugin) throw plain messages rather
  // than Firebase `auth/*` codes — treat a user dismissal as a quiet cancel.
  const message = ((err as { message?: string })?.message ?? '').toLowerCase();
  if (/cancel|canceled|cancelled|dismiss|1001|user closed/.test(message)) {
    return 'Sign-in was cancelled.';
  }
  switch (code) {
    case 'auth/invalid-email':
      return 'That email doesn’t look right.';
    case 'auth/missing-password':
    case 'auth/weak-password':
      return 'Password must be at least 6 characters.';
    case 'auth/email-already-in-use':
      return 'That email already has an account — try logging in.';
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return 'Email or password is incorrect.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Try again in a moment.';
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return 'Sign-in was cancelled.';
    case 'auth/operation-not-allowed':
      return 'That sign-in method isn’t enabled yet.';
    case 'auth/account-exists-with-different-credential':
      return 'You already signed up with a different method for this email.';
    default:
      return 'Something went wrong. Please try again.';
  }
}
